import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import CheckBoxWithAll from '@features/filter/v2/CheckBoxWithAll';
import FilterName from '@features/filter/v2/FilterName';

import { replaceSpace } from '@utils/Util';

const Designation = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [JSON.stringify(dependentFilterList)]);

	useEffect(() => {
		setData(allData);
	}, [JSON.stringify(selectedField)]);

	const filterData = {
		[allFilterPages.MY_COLLEAGUES]: dependentFilterList?.designaitonList
	};

	const onFetchData = async () => {
		let responseData = filterData[filterPageName] || [];
		responseData = responseData?.map((item, index) => {
			return {
				id: replaceSpace(item).toUpperCase() + index,
				name: item
			};
		});
		setAllData([{ id: 'ALL-STACKHOLDER', name: 'All' }, ...responseData]);
		setData([{ id: 'ALL-STACKHOLDER', name: 'All' }, ...responseData]);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};

	return (
		<>
			<FilterName type="DESIGNATION" />
			<CheckBoxWithAll data={data} type="DESIGNATION" handleSearch={handleSearch} />
		</>
	);
};

export default Designation;
